import { AnnotationEventDelegator } from './event-delegator'

export default function useAnnotationSubscriber(annotations: AnnotationEventDelegator): DrawingObserver {
  return {
    start(point) {
      annotations.trigger('start', point)
    },
    move(point) {
      annotations.trigger('move', point)
    },
    setup(opts) {
      annotations.trigger('setup', opts)
    },
    undo() {
      annotations.trigger('undo')
    },
    reset() {
      annotations.trigger('reset')
    },
  }
}
